import { lazy, Suspense } from "react";
import { HeroSection } from "@/components/HeroSection";
import { SecuritySection } from "@/components/SecuritySection";
import { Helmet, HelmetProvider } from "react-helmet-async";

// Below-the-fold sections: lazy-loaded to reduce initial JS bundle
const WorkflowIntegrationsSection = lazy(() => import("@/components/WorkflowIntegrationsSection").then(m => ({ default: m.WorkflowIntegrationsSection })));
const PricingSection = lazy(() => import("@/components/PricingSection").then(m => ({ default: m.PricingSection })));
const WorkflowAutomationSection = lazy(() => import("@/components/WorkflowAutomationSection").then(m => ({ default: m.WorkflowAutomationSection })));
const Stack24Section = lazy(() => import("@/components/Stack24Section").then(m => ({ default: m.Stack24Section })));
const ActionCenterSection = lazy(() => import("@/components/ActionCenterSection").then(m => ({ default: m.ActionCenterSection })));
const PriorityHubSection = lazy(() => import("@/components/PriorityHubSection").then(m => ({ default: m.PriorityHubSection })));
const CalendarIntelligenceSection = lazy(() => import("@/components/CalendarIntelligenceSection").then(m => ({ default: m.CalendarIntelligenceSection })));
const SmartFAQSection = lazy(() => import("@/components/SmartFAQSection").then(m => ({ default: m.SmartFAQSection })));
const SocialProofSection = lazy(() => import("@/components/SocialProofSection").then(m => ({ default: m.SocialProofSection })));
const Setup3StepSection = lazy(() => import("@/components/Setup3StepSection").then(m => ({ default: m.Setup3StepSection })));
const SecurityComplianceSection = lazy(() => import("@/components/SecurityComplianceSection").then(m => ({ default: m.SecurityComplianceSection })));
const FAQSection = lazy(() => import("@/components/FAQSection").then(m => ({ default: m.FAQSection })));
const FinalCTASection = lazy(() => import("@/components/FinalCTASection").then(m => ({ default: m.FinalCTASection })));
const Footer = lazy(() => import("@/components/Footer").then(m => ({ default: m.Footer })));
const ChatWidget = lazy(() => import("@/components/ChatWidget").then(m => ({ default: m.ChatWidget })));

const Index = () => {
  return (
    <>
          <HelmetProvider>
        <Helmet>
          <title>ClearMakes | AI-Powered Business Communication Hub</title>
          <meta name="description" content="ClearMakes unifies Gmail, Outlook, Slack, Teams, Instagram and Messenger. Automate replies, summarize threads, and manage priority conversations in one AI inbox." />
        </Helmet>
      </HelmetProvider>
<div className="min-h-screen bg-background text-foreground">
        
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@graph": [
                {
                  "@type": "WebSite",
                  "@id": "https://www.clearmakes.com/#website",
                  "url": "https://www.clearmakes.com/",
                  "name": "ClearMakes",
                  "description": "The Professional Workspace for unified messaging and AI communication.",
                  "publisher": { "@id": "https://www.clearmakes.com/#organization" },
                  "potentialAction": [{
                    "@type": "SearchAction",
                    "target": { "@type": "EntryPoint", "urlTemplate": "https://www.clearmakes.com/search?q={search_term_string}" },
                    "query-input": "required name=search_term_string"
                  }]
                },
                {
                  "@type": "Organization",
                  "@id": "https://www.clearmakes.com/#organization",
                  "name": "ClearMakes",
                  "url": "https://www.clearmakes.com/",
                  "logo": { "@type": "ImageObject", "url": "https://www.clearmakes.com/images/logo.png" },
                  "sameAs": [
                    "https://twitter.com/clearmakes",
                    "https://www.linkedin.com/company/clearmakes"
                  ]
                },
                {
                  "@type": "SoftwareApplication",
                  "@id": "https://www.clearmakes.com/#software",
                  "name": "ClearMakes Workspace",
                  "applicationCategory": "BusinessApplication",
                  "operatingSystem": "Web, Windows, macOS",
                  "url": "https://www.clearmakes.com/",
                  "offers": { "@type": "Offer", "price": "0.00", "priceCurrency": "USD" }
                }
              ]
            })
          }}
        />
      <main>
        {/* Above-the-fold: loaded eagerly for fast FCP/LCP */}
        <HeroSection />
        <SecuritySection />

        {/* Below-the-fold: lazy-loaded to cut initial JS bundle */}
        <Suspense fallback={null}>
          <WorkflowIntegrationsSection />
          <PricingSection />
          <WorkflowAutomationSection />
          <Stack24Section />
          <ActionCenterSection />
          <PriorityHubSection />
          <CalendarIntelligenceSection />
          <SmartFAQSection />
          <SocialProofSection />
          <Setup3StepSection />
          <SecurityComplianceSection />
          <FAQSection />
          <FinalCTASection />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
        <ChatWidget />
      </Suspense>
    </div>
    </>
  );
};

export default Index;
